module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "unnumbered-1",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-mixed"
  }, [_vm._v("One year earlier")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "unnumbered-1-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-s"
  }, [_c('i', [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("S")]), _vm._v("he sat in her usual chair in the therapist’s room, her hands clasped together, her shoulders hunched.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘Do you want to talk about the birth?’ Leah asked, handing her a mug of coffee.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("No, I don’t want to talk about the birth, she thought. The rain splashed at the windows and her eyesight blurred.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘I don’t really remember much,’ she said. It didn’t sound like her voice. It was too far away. ‘I know it was raining. I remember hailstones hitting the windows. I was excited that it was happening.’")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("She squeezed her hands tightly, the nails sharp and painful in her palms.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘I remember thinking it doesn’t matter about the pain. It would all be worth it, and it was.’")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘It’s a good memory?’")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("She nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘But I wanted three. I always wanted three. I’d planned that we’d have the second a year later. That way they could grow up together …’")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Her throat seemed to close up and she struggled to breathe.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘Do you need a glass of water?’ Leah asked kindly.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("She shook her head. All she seemed to do here was drink endless amounts of water.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘I still can’t accept it. I do try. I remember the pain, it went on for hours. I would have liked a natural birth but I was relieved when I was taken to the operating theatre. Everyone said I should be grateful to have a baby but I only felt disappointment and anger. It was my mother who told me that I couldn’t have any more’.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘Are you still angry with the doctors for taking away your womb?’")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("She shrugged. Her hand trembled and she carefully placed the mug of coffee on to the table next to a solitary box of tissues. She found herself wondering how often Leah replaces the box. Every day? Every few hours?")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘You need to get past this if we’re to move on. You have to accept.’")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("It’s easy for her to say, she thought angrily.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘Do you have a family?’ she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘It’s not about me,’ said Leah")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘I have to go,’ she said suddenly, standing up.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Leah didn’t seem surprised.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("At least she’d stayed longer than last time.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cff02e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/one-year-earlier.vue
// module id = 75
// module chunks = 0